module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUtJREFUeNpi8PDw+M8ABCCaiQEBBBlgMiAAEEBwDrOKigojENfDZQACiAHJhAYgFkARRFLUABBA2AT/wxgCYBVQwAQS2LFjxwcg+wGQfZ6BJAAQQBgW4QJMSBrmIzsAyO4HieE0EchPAOIADM2ErMYZQrgAQAAxwhQCw4ORXI+iaGBB9wiQUgDiC0AbNuAKHpA1G4AKQL48gG4tE1TRe5AbofEGAqDwWwASJyqmcCVFBiy+P4DhRhxgI8nBw0SsYoAAIz30qWYzkYAFh00FQAqUgwWQQxIIHIAYFHeNwNCeQNBAaJoHGZQI1CCIx2sJ0KAqRDeYBUkRyPZ4UNGDlILguRNIgdLpAiB+CMT2UClQLn2AnG5ZkBIMyGuKWFwDsugijuwESqoGoLSONwzRUuYBtHBEBqAwfkAwUogF2FxNm2SDnrix2UxspgAAFUmSWBn7eA0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/icon/zhanghu.png
// module id = r8Lw
// module chunks = 1